import React from "react";
import { Grid, Box, Typography } from "@mui/material";
import image from "../../assets/updatedBannerImage/updatebannerplane.png";

const ImageSection = () => {
  return (
    <Grid
      sx={{
        height: { md: "80vh", xs: "50vh" },
        width: "100%",
        position: "relative",
        backgroundImage: `url(${image})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        overflow: "hidden",
      }}
    >
      {/* Text Content at Bottom Center with Black Background */}
      <Box
        sx={{
          position: "absolute",
          bottom: 0,
          left: "50%",
          transform: "translateX(-50%)",
          textAlign: "center",
          backgroundColor: "rgba(0, 0, 0, 0.5)", // thin black background
          color: "#fff",
          px: 3,
          py: 2,
          width: "100%",
          maxWidth: "100%",
        }}
      >
        <Typography
          variant="h4"
          sx={{
            fontWeight: 700,
            fontSize: { xs: "1.3rem", md: "2.2rem" },
             fontFamily: "Montserrat, sans-serif",
            mb: 1,
          }}
        >
          “OUR REEF OUR LIFE”
        </Typography>

        <Typography
          variant="h6"
          sx={{
            fontWeight: 700,
            fontSize: { xs: "0.9rem", sm: "1.1rem", md: "1.4rem" },
            fontFamily: "Montserrat, sans-serif",
            lineHeight: 1.5,
          }}
        >
          The ocean’s future begins with the choices we make today — act now,<br />
          so the waves of tomorrow carry life, not loss
        </Typography>
      </Box>
    </Grid>
  );
};

export default ImageSection;
